import _ from 'lodash';

import { Report } from '@/pages/Report/types';

export const onNullableCell = (record: Report) =>
  _.isNil(record.vaccinatedIndividualsAmount) ? { style: { color: '#E31F1F' } } : {};

export const amountCols = (width: number = 110) => [
  {
    title: 'Кол-во вакцинаций',
    dataIndex: 'plannedIndividualsAmount',
    key: 'plannedIndividualsAmount',
    sorter: true,
    width,
  },
  {
    title: 'Кол-во проведенных вакцинаций',
    dataIndex: 'vaccinatedIndividualsAmount',
    key: 'vaccinatedIndividualsAmount',
    sorter: true,
    width,
    payload: { defaultValue: 'Не выполнен' },
    onCell: onNullableCell,
  },
  {
    title: 'Кол-во вакцинаций в листе ожидания',
    dataIndex: 'waitingListAmount',
    key: 'waitingListAmount',
    sorter: true,
    width,
    payload: { defaultValue: '-' },
    onCell: onNullableCell,
  },
];

export const reasonsCol = {
  title: 'Причины непроведения вакцинации',
  children: [
    {
      title: () => <div className="verticalText">заболевание</div>,
      dataIndex: 'vaccinationCancelSickAmount',
      width: 50,
      className: 'columnWidth',
      payload: { defaultValue: '-' },
      onCell: onNullableCell,
    },
    {
      title: () => <div className="verticalText">падеж</div>,
      dataIndex: 'vaccinationCancelDeadAmount',
      width: 50,
      className: 'columnWidth',
      payload: { defaultValue: '-' },
      onCell: onNullableCell,
    },
    {
      title: () => <div className="verticalText">иное</div>,
      dataIndex: 'vaccinationCancelLackOfVaccineAmount',
      width: 50,
      className: 'columnWidth',
      payload: { defaultValue: '-' },
      onCell: onNullableCell,
    },
  ],
};

export const rateCol = (width: number = 110) => ({
  title: 'Показатель соответствия (%)',
  dataIndex: 'complianceRate',
  key: 'complianceRate',
  sorter: true,
  width,
  payload: { defaultValue: '-' },
  onCell: onNullableCell,
});

export const indexCol = {
  title: '№ п/п',
  dataIndex: 'index',
  width: 60,
};
